import React, { useState, useEffect } from 'react';
import axios from 'axios';

import StartApplicationFormDebug from './StartApplicationFormDebug';
import style from './StartApplicationPage.module.css';

const StartApplicationPage = React.memo(({ match, history }) => {
  const [error, setError] = useState('');
  const [startAppForm, setStartAppForm] = useState({});
  const { clientId } = match.params;

  const queryParameters = history.location.search;
  const params = new URLSearchParams(queryParameters);

  useEffect(() => {
    axios
      .get(
        `${
          process.env.REACT_APP_BASE_URL
        }hub/applicationinitiations/${clientId || ''}?forProfit=${params.get(
          'forProfit',
        ) || false}`,
      )
      .then(response => {
        setStartAppForm(response.data);
      })
      .catch(() => setError('Something went wrong. Please try again.'));

    document.title = 'HUB Portal: Start Application';
  }, []);

  return (
    <div className={style.startApp}>
      <h1 className={style.h1}>
        HUB Management Liability Universal Application
      </h1>
      <StartApplicationFormDebug model={startAppForm} error={error} />
    </div>
  );
});

export default StartApplicationPage;
